import Header from './components/Header';
import Hero from './components/Hero';
import SectionIndex from './components/SectionIndex';
import SectionContact from './components/SectionContact';
import SectionTopics from './components/SectionTopics';
import SectionFeatures from './components/SectionFeatures';
import SectionRanking from './components/SectionRanking';
import SectionApp from './components/SectionApp';
import SectionCards from './components/SectionCards';
import SectionComments from './components/SectionComments';
import SectionUpdates from './components/SectionUpdates';
import SectionFaq from './components/SectionFaq';
import SectionMedia from './components/SectionMedia';
import SectionCarousel from './components/SectionCarousel';
import SectionAbout from './components/SectionAbout';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-100">
      <Header />
      <main>
        <Hero />
        <SectionIndex />
        <SectionContact />
        <SectionTopics />
        <SectionFeatures />
        <SectionRanking />
        <SectionApp />
        <SectionCards />
        <SectionComments />
        <SectionUpdates />
        <SectionFaq />
        <SectionMedia />
        <SectionCarousel />
        <SectionAbout />
      </main>
      <Footer />
    </div>
  );
}